// ==============================|| OVERRIDES - TABLE ROW ||============================== //

export default function TableRow() {
  return {
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:last-of-type': {
            '& .MuiTableCell-root': {
              borderBottom: 'none'
            }
          },
          '& .MuiTableCell-root': {
            '&:last-of-type': {
              paddingInlineEnd: 24  // Logical: right in LTR, left in RTL
            },
            '&:first-of-type': {
              paddingInlineStart: 24  // Logical: left in LTR, right in RTL
            }
          }
        }
      }
    }
  };
}
